//禁止右键
document.oncontextmenu = function(){
  return false;
}